import { BackendConfigField } from "../types/types"

export const getRegionsFromConfigEntries = (fields: BackendConfigField[]) => {
    const entry = fields.find(item => item.name.toUpperCase() === "REGIONS")

    if (!entry) return ["westeurope"]

    return entry.value.replace(" ", "").split(",")
} 